<script lang="ts">
    import logo from '@src/assets/img/bg_logo.webp';

    let className = '';
    export { className as class };
</script>

<img src={logo} alt="logo" class={className} />
